import ContentModuleTab from './ContentModuleTab';

export default ContentModuleTab;
